<template>
  <div :class="['index-root',{'fadeout':fadeout}]" @click="next()">
    <div class="top-hand"></div>
    <div class="bottom-hand"></div>
  </div>
</template>

<script>

export default {
  name: 'Index',
  data () {
    return {
      fadeout:false
    }
  },
  mounted() {
    setTimeout(this.next, 2500)
    const article = this.$route.query.article
    const resultBg = require(`../assets/result/${article}/share${article}.png`)
    this.$preloadImg({
      src:resultBg,
      isBg: true,
      name:'bg',
      z: 1
    })
  },
  methods: {
    next() {
      this.fadeout = true
      const name = this.$route.query.name || '你'
      const random = this.$route.query.article
      setTimeout(() => this.$router.push(`/intro?name=${name}&article=${random}`),500)
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.index-root {
  height: 100%;
  width: 100%;
  position: relative;
  background: url("../assets/index_bg.jpg") center no-repeat;
  background-size: cover;
  transition: opacity .5s ease-in-out;
}
  .top-hand{
    position: absolute;
    top:0;
    left:50%;
    width: 60vh;
    height:43.76vh;
    transform: translateX(-50%);
    background-image: url("../assets/index_hand_top.png");
    background-size: cover;
    animation: handdown 10s .5s infinite;
  }
.bottom-hand{
  position: absolute;
  bottom:0;
  left:50%;
  width: 60vh;
  height:48.56vh;
  transform: translateX(-50%);
  background-image: url("../assets/index_hand_bottom.png");
  background-size: cover;
  animation: handup 10s .5s infinite;
}
.fadeout{
  opacity: 0.5;
}
  @keyframes handdown {
    0%{
      top:-1rem;
    }
    50%{
      top: 0;
    }
    100%{
      top:-1rem;
    }
  }
@keyframes handup {
  0%{
    bottom:-1rem;
  }
  50%{
    bottom: 0;
  }
  100%{
    bottom: -1rem;
  }
}

</style>



// WEBPACK FOOTER //
// src/pages/Index.vue